"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppsClaim = void 0;
var BackOfficeClaim_1 = require("./claims/BackOfficeClaim");
var CloudAgentSuiteClaim_1 = require("./claims/CloudAgentSuiteClaim");
var HomeSpotterBoostClaim_1 = require("./claims/HomeSpotterBoostClaim");
var HomeSpotterConnectClaim_1 = require("./claims/HomeSpotterConnectClaim");
var HomeSpotterSpacioClaim_1 = require("./claims/HomeSpotterSpacioClaim");
var LionDeskClaim_1 = require("./claims/LionDeskClaim");
var PropertybaseBackOfficeClaim_1 = require("./claims/PropertybaseBackOfficeClaim");
var PropertybaseBoldLeadsClaim_1 = require("./claims/PropertybaseBoldLeadsClaim");
var PropertybaseGoClaim_1 = require("./claims/PropertybaseGoClaim");
var SalesforceClaim_1 = require("./claims/SalesforceClaim");
var TransactionDeskClaim_1 = require("./claims/TransactionDeskClaim");
var TerradatumAergoClaim_1 = require("./claims/TerradatumAergoClaim");
var TerradatumAgentMetricsClaim_1 = require("./claims/TerradatumAgentMetricsClaim");
var XBrokerMetricsClaim_1 = require("./claims/XBrokerMetricsClaim");
var TerradatumListingHomeRunClaim_1 = require("./claims/TerradatumListingHomeRunClaim");
var TerradatumVScreenClaim_1 = require("./claims/TerradatumVScreenClaim");
var WolfConnectClaim_1 = require("./claims/WolfConnectClaim");
var ZipFormPlusClaim_1 = require("./claims/ZipFormPlusClaim");
var AuthentisignClaim_1 = require("./claims/AuthentisignClaim");
var BackOfficeV4Claim_1 = require("./claims/BackOfficeV4Claim");
var CloudAttractClaim_1 = require("./claims/CloudAttractClaim");
var CloudCMAClaim_1 = require("./claims/CloudCMAClaim");
var CloudMLXClaim_1 = require("./claims/CloudMLXClaim");
var CloudStreamsClaim_1 = require("./claims/CloudStreamsClaim");
var TransactWorkflowClaim_1 = require("./claims/TransactWorkflowClaim");
var AppsClaim = /** @class */ (function () {
    function AppsClaim() {
    }
    AppsClaim.prototype.populate = function (appsClaimObject) {
        this.as = this.createApplicationClaim(AuthentisignClaim_1.AuthentisignClaim, appsClaimObject, "as");
        this.bo = this.createApplicationClaim(BackOfficeClaim_1.BackOfficeClaim, appsClaimObject, "bo");
        this.bov = this.createApplicationClaim(BackOfficeV4Claim_1.BackOfficeV4Claim, appsClaimObject, "bov");
        this.cas = this.createApplicationClaim(CloudAgentSuiteClaim_1.CloudAgentSuiteClaim, appsClaimObject, "cas");
        this.ca = this.createApplicationClaim(CloudAttractClaim_1.CloudAttractClaim, appsClaimObject, "ca");
        this.cc = this.createApplicationClaim(CloudCMAClaim_1.CloudCMAClaim, appsClaimObject, "cc");
        this.cm = this.createApplicationClaim(CloudMLXClaim_1.CloudMLXClaim, appsClaimObject, "cm");
        this.cs = this.createApplicationClaim(CloudStreamsClaim_1.CloudStreamsClaim, appsClaimObject, "cs");
        this.hsb = this.createApplicationClaim(HomeSpotterBoostClaim_1.HomeSpotterBoostClaim, appsClaimObject, "hsb");
        this.hsc = this.createApplicationClaim(HomeSpotterConnectClaim_1.HomeSpotterConnectClaim, appsClaimObject, "hsc");
        this.hss = this.createApplicationClaim(HomeSpotterSpacioClaim_1.HomeSpotterSpacioClaim, appsClaimObject, "hss");
        this.ld = this.createApplicationClaim(LionDeskClaim_1.LionDeskClaim, appsClaimObject, "ld");
        this.pbb = this.createApplicationClaim(PropertybaseBackOfficeClaim_1.PropertybaseBackOfficeClaim, appsClaimObject, "pbb");
        this.pbl = this.createApplicationClaim(PropertybaseBoldLeadsClaim_1.PropertybaseBoldLeadsClaim, appsClaimObject, "pbl");
        this.pbg = this.createApplicationClaim(PropertybaseGoClaim_1.PropertybaseGoClaim, appsClaimObject, "pbg");
        this.sf = this.createApplicationClaim(SalesforceClaim_1.SalesforceClaim, appsClaimObject, "sf");
        this.tra = this.createApplicationClaim(TerradatumAergoClaim_1.TerradatumAergoClaim, appsClaimObject, "tra");
        this.trr = this.createApplicationClaim(TerradatumAgentMetricsClaim_1.TerradatumAgentMetricsClaim, appsClaimObject, "trr");
        this.trl = this.createApplicationClaim(TerradatumListingHomeRunClaim_1.TerradatumListingHomeRunClaim, appsClaimObject, "trl");
        this.td = this.createApplicationClaim(TransactionDeskClaim_1.TransactionDeskClaim, appsClaimObject, "td");
        this.tw = this.createApplicationClaim(TransactWorkflowClaim_1.TransactWorkflowClaim, appsClaimObject, "tw");
        this.trv = this.createApplicationClaim(TerradatumVScreenClaim_1.TerradatumVScreenClaim, appsClaimObject, "trv");
        this.wc = this.createApplicationClaim(WolfConnectClaim_1.WolfConnectClaim, appsClaimObject, "wc");
        this.xbm = this.createApplicationClaim(XBrokerMetricsClaim_1.XBrokerMetricsClaim, appsClaimObject, "xbm");
        this.zfp = this.createApplicationClaim(ZipFormPlusClaim_1.ZipFormPlusClaim, appsClaimObject, "zfp");
    };
    AppsClaim.prototype.createApplicationClaim = function (claimType, appsClaimObject, claimPropertyName) {
        var claimObject;
        if (appsClaimObject[claimPropertyName]) {
            claimObject = new claimType();
            Object.assign(claimObject, appsClaimObject[claimPropertyName]);
        }
        return claimObject;
    };
    AppsClaim.prototype.getAuthentisignClaim = function () {
        return this.as;
    };
    AppsClaim.prototype.getBackOfficeClaim = function () {
        return this.bo;
    };
    AppsClaim.prototype.getBackOfficeV4Claim = function () {
        return this.bov;
    };
    AppsClaim.prototype.getCloudAgentSuiteClaim = function () {
        return this.cas;
    };
    AppsClaim.prototype.getCloudAttractClaim = function () {
        return this.ca;
    };
    AppsClaim.prototype.getCloudCMAClaim = function () {
        return this.cc;
    };
    AppsClaim.prototype.getCloudMLXClaim = function () {
        return this.cm;
    };
    AppsClaim.prototype.getCloudStreamsClaim = function () {
        return this.cs;
    };
    AppsClaim.prototype.getHomeSpotterBoostClaim = function () {
        return this.hsb;
    };
    AppsClaim.prototype.getHomeSpotterConnectClaim = function () {
        return this.hsc;
    };
    AppsClaim.prototype.getHomeSpotterSpacioClaim = function () {
        return this.hss;
    };
    AppsClaim.prototype.getLionDeskClaim = function () {
        return this.ld;
    };
    AppsClaim.prototype.getPropertybaseBackOfficeClaim = function () {
        return this.pbb;
    };
    AppsClaim.prototype.getPropertybaseBoldLeadsClaim = function () {
        return this.pbl;
    };
    AppsClaim.prototype.getPropertybaseGoClaim = function () {
        return this.pbg;
    };
    AppsClaim.prototype.getSalesforceClaim = function () {
        return this.sf;
    };
    AppsClaim.prototype.getTerradatumAergoClaim = function () {
        return this.tra;
    };
    AppsClaim.prototype.getTerradatumAgentMetricsClaim = function () {
        return this.trr;
    };
    AppsClaim.prototype.getTerradatumListingHomeRunClaim = function () {
        return this.trl;
    };
    AppsClaim.prototype.getTerradatumVScreenClaim = function () {
        return this.trv;
    };
    AppsClaim.prototype.getTransactionDeskClaim = function () {
        return this.td;
    };
    AppsClaim.prototype.getTransactWorkflowClaim = function () {
        return this.tw;
    };
    AppsClaim.prototype.getWolfConnectClaim = function () {
        return this.wc;
    };
    AppsClaim.prototype.getXBrokerMetricsClaim = function () {
        return this.xbm;
    };
    AppsClaim.prototype.getZipFormPlusClaim = function () {
        return this.zfp;
    };
    return AppsClaim;
}());
exports.AppsClaim = AppsClaim;
